export interface Color {
  name: string
  hexCode: string
}

export const colors: Color[] = [
  { name: 'Beekeeper', hexCode: '#f6e58d' },
  { name: 'Turbo', hexCode: '#f9ca24' },
  { name: 'Spiced Nectarine', hexCode: '#ffbe76' },
  { name: 'Quince Jelly', hexCode: '#f0932b' },
  { name: 'Pink Glamour', hexCode: '#ff7979' },
  { name: 'Carmine Pink', hexCode: '#eb4d4b' },
  { name: 'June Bud', hexCode: '#badc58' },
  { name: 'Pure Apple', hexCode: '#6ab04c' },
  { name: 'Coastal Breeze', hexCode: '#dff9fb' },
  { name: 'Hint of Ice Pack', hexCode: '#c7ecee' },
  { name: 'Middle Blue', hexCode: '#7ed6df' },
  { name: 'Greenland Green', hexCode: '#22a6b3' },
  { name: 'Heliotrop', hexCode: '#e056fd' },
  { name: 'Steel Pink', hexCode: '#be2edd' },
  { name: 'Exodus Fruit', hexCode: '#686de0' },
  { name: 'Blurple', hexCode: '#4834d4' },
  { name: 'Deep Komaru', hexCode: '#30336b' },
  { name: 'Deep Cove', hexCode: '#130f40' },
  { name: 'Soaring Eagle', hexCode: '#95afc0' },
  { name: 'Wizard Grey', hexCode: '#535c68' },
]

/** The palette name of a hex, or the hex itself when it is not one of `colors`. */
export const colorName = (hexCode: string): string =>
  colors.find((color) => color.hexCode.toLowerCase() === hexCode.toLowerCase())?.name ?? hexCode
